import React, { FunctionComponent } from 'react';
import ReactDOMServer from 'react-dom/server';
import classnames from 'classnames';
import HtmlToReact, { Parser } from 'html-to-react';

import { IndexStructure, Props } from './index';
import StyledComponent from './styles';

const PublicBlogsArticleWrapper: FunctionComponent<Props> = ({ article, children, customClassName }) => {
    const htmlToReactParser = new Parser();

    const indexStructure: IndexStructure = {};
    let lastLevel1Id = 0;
    let lastLevel2Id = 0;
    let lastLevel3Id = 0;

    const preprocessingInstructions = [{
        replaceChildren: false,
        shouldPreprocessNode (node) {
            return node.name && node.name  === 'h2' && node.children && node.children[0];
        },
        preprocessNode (node) {
            lastLevel1Id = lastLevel1Id + 1;
            lastLevel2Id = 0;
            lastLevel3Id = 0;
            indexStructure[lastLevel1Id] = {
                key: `1-${lastLevel1Id}`,
                level: 1,
                order: lastLevel1Id,
                text: node.children?.[0]?.children?.[0] ? node?.children?.[0].children?.[0]?.data : node.children?.[0]?.data,
                elements: {},
            };

            node.attribs = {
                ...node.attribs,
                id: `indexl1-${lastLevel1Id}`,
            };
        },
    }, {
        replaceChildren: false,
        shouldPreprocessNode (node) {
            return node.name && node.name === 'h3' && node.children && node.children[0];
        },
        preprocessNode (node) {
            if (indexStructure[lastLevel1Id]) {
                if (indexStructure[lastLevel1Id].elements[lastLevel2Id]) {
                    lastLevel3Id = lastLevel3Id + 1;
                    indexStructure[lastLevel1Id].elements[lastLevel2Id].elements[lastLevel3Id] = {
                        key: `3-${lastLevel3Id}`,
                        level: 3,
                        order: lastLevel3Id,
                        text: node.children[0]?.data,
                        elements: {},
                    };
                } else {
                    lastLevel2Id = lastLevel2Id + 1;
                    lastLevel3Id = 0;
                    indexStructure[lastLevel1Id].elements[lastLevel2Id] = {
                        key: `2-${lastLevel2Id}`,
                        level: 2,
                        order: lastLevel2Id,
                        text: node.children[0]?.data,
                        elements: {},
                    };
                }
            } else {
                lastLevel1Id = lastLevel1Id + 1;
                lastLevel2Id = 0;
                lastLevel3Id = 0;
                indexStructure[lastLevel1Id] = {
                    key: `1-${lastLevel1Id}`,
                    level: 1,
                    order: lastLevel1Id,
                    text: node.children[0]?.data,
                    elements: {},
                };
            }

            node.attribs = {
                ...node.attribs,
                id: `indexl2-${lastLevel2Id}`,
            };
        },
    }, {
        replaceChildren: false,
        shouldPreprocessNode (node) {
            return node.name && node.name === 'h4' && node.children && node.children[0];
        },
        preprocessNode (node) {
            lastLevel3Id = lastLevel3Id + 1;
            indexStructure[lastLevel1Id].elements[lastLevel2Id].elements[lastLevel3Id] = {
                key: `3-${lastLevel3Id}`,
                level: 3,
                order: lastLevel3Id,
                text: node.children?.[0]?.children?.[0] ? node?.children?.[0].children?.[0]?.data : node.children?.[0]?.data,
                elements: {},
            };
            node.attribs = {
                ...node.attribs,
                id: `indexl3-${lastLevel3Id}`,
            };
        },
    }];

    const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
    const processingInstructions = [{
        shouldProcessNode: () => true,
        processNode: processNodeDefinitions.processDefaultNode,
    }];

    const content = ReactDOMServer.renderToStaticMarkup(
        htmlToReactParser.parseWithInstructions(
            article?.content,
            () => true,
            processingInstructions,
            preprocessingInstructions
        )
    );

    return (
        <StyledComponent className={classnames('public-layout-articles-wrapper', customClassName)}>
            {children(content, indexStructure)}
        </StyledComponent>
    );
};

export default PublicBlogsArticleWrapper;